import { types } from 'mobx-state-tree'
const { model, maybeNull, boolean } = types

const AccountControl = model({
  employerContribution: maybeNull(boolean),
  paycheckContribution: maybeNull(boolean),
})

export default AccountControl
